import BC from '../init';
import Swiper from 'swiper';

export default BC.Methods.gridSlider = ($this) => {

    const slider = $this.querySelector('.swiper');

    const breakpoint = window.matchMedia('(min-width: 1200px)');
    let gridSwiper;

    const breakpointChecker = function() {
        if (breakpoint.matches) {
            if (gridSwiper !== undefined) gridSwiper.destroy(true, true);
            return;
        } else if (!breakpoint.matches) {
            return enableSwiper();
        }
    };

    const enableSwiper = function() {
        gridSwiper = new Swiper(slider, {
            speed: 1000,
            slidesPerView: 1.7,
            spaceBetween: 10,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 3.05,
                    spaceBetween: 12,
                }
            }
        });
    };

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker();
};
